import {Alert} from 'src/design/atoms/Alert';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import {ModuleEnum, TaskTypeEnum} from 'src/api/ProactApiClient';
import {CreateButton} from 'src/design/molecules/CreateButton';
import {RelatedTaskAssignmentsList} from 'src/pages/Modules/Forms/User/ViewForm/components/ActionsTab/RelatedTaskAssignmentsList';
import {RelatedTaskDefinitionList} from 'src/pages/Modules/Forms/User/ViewForm/components/ActionsTab/RelatedTaskDefinitionList';
import {useTaskPermissions} from 'src/shared/auth/permissions/useTaskPermissions';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSkipTokensByFeature from 'src/shared/hooks/useSkipTokensByFeature';
import {IconPlus} from '@tabler/icons-react';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export interface ActionsTabProps {
  formId: number;
}
export const ActionsTab: React.FC<ActionsTabProps> = ({formId}) => {
  const navigate = useAppNavigate();
  const {skipActions} = useSkipTokensByFeature();
  const taskPerms = useTaskPermissions(ModuleEnum.Actions);

  const handleAddClick = () => navigate(PathUtility.ActionCreate(formId));

  if (skipActions) {
    return null;
  }

  return (
    <>
      <Alert
        color="yellow"
        mt="xl"
        mb="xl"
        title="Add New Action"
        icon={<IconPlus />}>
        {taskPerms.create ? (
          <>
            <Text mb="lg">
              Use the "Add New" button below to create an action. You must
              publish the action before it will be assigned to other users and
              shown in the "Action Assignments" section below. Until then, your
              created action will be in "Draft" status in the "Action
              Definitions" section below.
            </Text>
            <CreateButton size="sm" onClick={handleAddClick} />
          </>
        ) : (
          <>
            <Text mb="lg">
              Use the "Add New" button below to create an action and send it to
              your administrator for review. Your administrator must publish the
              action before it will be assigned to other users and shown in the
              "Action Assignments" section below. Until then, your created
              action will be in "Draft" status in the "Action Definitions"
              section below.
            </Text>
            <CreateButton size="sm" onClick={handleAddClick} />
          </>
        )}
      </Alert>

      <RelatedTaskDefinitionList
        taskType={TaskTypeEnum.Actions}
        filterFormId={formId}
      />
      <RelatedTaskAssignmentsList formId={formId} />
    </>
  );
};
